<script lang="ts">
export default {
    name: "SideBar",
};
</script>

<script setup lang="ts">
import { useRoute } from 'vue-router'
import { onMounted } from 'vue';

const route = useRoute()
const menus = ref([
    {
        path: "/home",
        name:"首页",
    },
    {
        path: "/event",
        name:"港航事件",
    },
    {
        path: "/analysis",
        name:"综合分析",
    },
    {
        path: "/monitor",
        name:"实时监控",
    },
])

onMounted(()=>{
    console.log(route.path)
})
</script>

<template>
    <div class="sideBar">
        <div class="menuBox flex-display">
            <!-- <router-link v-for="(item,index) in menus" :to="{ path: item.path }" class="tags-item" :class="{ 'tags-item-active' : item.path == route.path  }">
                <span>
                    {{ item.name }}
                </span>
            </router-link> -->
        </div>
    </div>
</template>

<style scoped lang="scss">
.sideBar{
    width: 51vw;
    height: 10.2vh;
    // background-color: antiquewhite;
    .menuBox{
        .tags-item:nth-child(1){
            margin-left: 0;
        }
        .tags-item{
            width: 8.6vw;
            height: 4.5vh;
            margin-top: 0.7rem;
            // background-color: azure;
            text-align: center;
            line-height: 4.5vh;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 1.25rem;
            color: #8acfe6;
            background: url("@/assets/images/route-pic.png") no-repeat center;
            background-size: 100% 100%;
            margin-left: 2.25rem;
            span{
                display: inline-block;
            }
        }
        .tags-item-active{
            background: url("@/assets/images/route-bj.png") no-repeat center;
            background-size: 100% 100%;
            color: #FFFFFF;
        }
    }
}
</style>
